/* eslint-disable array-callback-return */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { AiOutlineCloseCircle } from "react-icons/ai";
import { useDispatch, useSelector } from "react-redux";
import { getAllLabel, getAllVisibleTo } from "../../Redux/CommonSlice";
import { handleAddPerson, } from "../../Redux/PersonSlice";
import { fetchApiData } from "../../Redux/organizationSlice";
import ReactSelect from "../Common/ReactSelect";
import { FiPlusCircle } from "react-icons/fi";
import AddLabel from "../Common/AddLabel";
import { FaPlus } from "react-icons/fa6";
import { RiDeleteBinLine } from "react-icons/ri";
import PhoneInput from "react-phone-input-2";

const AddEditPerson = ({ togglemodel, Person, setLoadFirst }) => {
  const { register, handleSubmit, setValue, formState: { errors }, } = useForm();
  const dispatch = useDispatch();
  const store = useSelector((state) => state.root.common);
  const organizationstore = useSelector((state) => state.root.organization);

  const [selectedOrganization, setSelectedOrganization] = useState(0);
  const [selectedVisible, setselectedVisible] = useState(1);
  const [selectedLable, setselectedLable] = useState(0);
  const [allPhone, setAllPhone] = useState([{ phone: "", Type: "Home", country: 'in' }]);
  const [allEmail, setAllEmail] = useState([{ email: "", Type: "Home" }]);
  const [openLabelModel, setOpenLabelModel] = useState(false);
  const [error, setErrors] = useState({});
  const modalTitle = Person?.personMasterID ? "Update Person" : "Add Person";

  useEffect(() => {
    dispatch(getAllLabel({}));
    dispatch(getAllVisibleTo({}));
    dispatch(fetchApiData({}))
  }, []);

  useEffect(() => {
    if (Person && Person) {
      setValue("name", Person.name)
      if (Person && Person.organizationID) { setSelectedOrganization({ label: Person.organizationName, value: Person.organizationID }) }
      if (Person && Person.labelID) setselectedLable({ label: Person.labelName, value: Person.labelID })
      if (Person && Person.visibleToID) setselectedVisible({ label: Person.visibleName, value: Person.visibleToID })

      if (Person.personPhoneDetails) {
        setAllPhone(
          Person && Person.personPhoneDetails.map((x) => ({
            phone: x.phoneNumber,
            Type: x.phoneType,
          }))
        );
      }
      if (Person.personEmailDetails) {
        setAllEmail(
          Person && Person.personEmailDetails.map((x) => ({
            email: x.email,
            Type: x.emailType,
          }))
        );
      }
    }
  }, [Person]);


  const handleOrgChange = (selectedOption) => { setSelectedOrganization(selectedOption); };
  const handleVisibleChange = (selectedOption) => { setselectedVisible(selectedOption); };
  const handleLableChange = (selectedOption) => { setselectedLable(selectedOption); };

  const handlePhoneChange = (value, index, country) => {
    const updatedPhones = [...allPhone];
    updatedPhones[index] = { ...updatedPhones[index], phone: value };
    updatedPhones[index] = { ...updatedPhones[index], country: country?.dialCode };
    setAllPhone(updatedPhones);

    const newErrors = { ...Error };
    delete newErrors[`Phone-${index}`];
    setErrors(newErrors)
  };


  const handleEmailChange = (event, index) => {
    const { value } = event.target;
    const updatedEmails = [...allEmail];
    updatedEmails[index].email = value;
    setAllEmail(updatedEmails);

    const newErrors = { ...error };
    delete newErrors[`Email-${index}`];
    setErrors(newErrors)
  };

  const handleEmailTypeChange = (e, index) => {
    const { value } = e.target;
    const updatedEmails = [...allEmail];
    updatedEmails[index].Type = value;
    setAllEmail(updatedEmails);
  };

  const handlePhoneTypeChange = (e, index) => {
    const { value } = e.target;
    const updatedPhones = [...allPhone];
    updatedPhones[index].Type = value;
    setAllPhone(updatedPhones);
  };

  const validateFields = () => {
    const newErrors = {};

    const phoneNumbers = allPhone.map(item => item?.phone?.trim());
    const phoneNumberCount = phoneNumbers.reduce((count, phone) => {
      count[phone] = (count[phone] || 0) + 1;
      return count;
    }, {});

    allPhone.forEach((item, index) => {
      const phoneNumber = item?.phone?.trim();
      const countryCode = item?.country?.length

      if (!item.phone) {
        newErrors[`Phone-${index}`] = 'Phone Number is required';
      } else if ((countryCode === 1 && phoneNumber?.length <= 10) || (countryCode === 2 && phoneNumber?.length <= 11) || (countryCode === 3 && (phoneNumber?.length <= 10))) {
        newErrors[`Phone-${index}`] = 'Invalid Phone Number';
      } else if (phoneNumberCount[phoneNumber] > 1) {
        if (phoneNumbers.indexOf(phoneNumber) !== index) {
          newErrors[`Phone-${index}`] = 'Phone Number already exists';
        }
      }

    });
    const emailRegex = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i;
    const emailAddresses = allEmail.map(item => item?.email?.trim());
    const emailCount = emailAddresses.reduce((count, email) => {
      count[email] = (count[email] || 0) + 1;
      return count;
    }, {});

    allEmail.forEach((item, index) => {
      const email = item?.email?.trim();
      if (!email) {
        newErrors[`Email-${index}`] = 'Email is required';
      }
      else if (!emailRegex.test(email)) {
        newErrors[`Email-${index}`] = 'Invalid Email address';
      }
      else if (emailCount[email] > 1) {
        if (emailAddresses.indexOf(email) !== index) {
          newErrors[`Email-${index}`] = 'Email already exists';
        }
      }
    });
    return newErrors;
  };

  const onSubmit = (data) => {
    const validationErrors = validateFields();
    if (Object.keys(validationErrors).length > 0) return setErrors(validationErrors);

    let PhoneDetails = [];
    let EmailDetails = [];

    allPhone?.map((item) => {
      let obj = {
        personPhoneDetailsID: 0,
        personMasterID: 0,
        phoneNumber: item?.phone,
        phoneType: item?.Type,
      };
      PhoneDetails?.push(obj);
    });

    allEmail?.map((item) => {
      let obj = {
        personEmailDetailsID: 0,
        personMasterID: 0,
        email: item?.email,
        emailType: item?.Type,
      };
      EmailDetails?.push(obj);
    });

    let Params = {
      personMasterID: Person?.personMasterID ? Person?.personMasterID : 0,
      name: data?.name,
      organizationID: selectedOrganization && selectedOrganization.value,
      labelID: selectedLable.value,
      ownerID: 0,
      visibleToID: selectedVisible && selectedVisible.value,
      userID: 0,
      personPhoneDetails: PhoneDetails,
      personEmailDetails: EmailDetails,
    };

    try {
      dispatch(handleAddPerson(Params)).then((res) => {
        if (res?.payload?.status === true) {
          setLoadFirst(true)
          togglemodel();
          setAllEmail([{ email: "", Type: "Home", },]);
          setAllPhone([{ phone: "", Type: "Home", },]);
        }
      });
    } catch (error) {
      console.log("error", error);
    }
  };

  return (
    <>
      <div
        id="default-modal"
        tabIndex="-1"
        aria-hidden="true"
        className="lead-modal-backdrop"
      >
        <div className="lead-modal-shell">
          <div className="lead-modal-card">
            <div className="lead-modal-header">
              <div>
                <h3 className="lead-modal-title">{modalTitle}</h3>
              </div>
              <AiOutlineCloseCircle
                className="lead-modal-close"
                onClick={() => togglemodel()}
              />
            </div>
            <form onSubmit={handleSubmit(onSubmit)}>
              <div className="lead-modal-body">
                <div className="lead-modal-grid vertical-scroll-inner">
                  <div className="lead-modal-section">
                    <div className="lead-modal-section-header">
                      <span className="lead-modal-section-dot" />
                      <h4>Person details</h4>
                    </div>
                    <div className="lead-modal-section-content">
                      <div className="lead-modal-field">
                        <label htmlFor="name" className="lead-modal-label">Name</label>
                        <input
                          type="text"
                          id="name"
                          name="name"
                          placeholder="Enter Name"
                          className="lead-modal-input capitalize"
                          {...register("name", { required: "Name is required" })}
                        />
                        {errors.name && <p className="lead-modal-error">{errors.name.message}</p>}
                      </div>

                      <div className="lead-modal-field">
                        <label htmlFor="organization" className="lead-modal-label">Organization</label>
                        <ReactSelect
                          selectedValue={selectedOrganization}
                          options={organizationstore && organizationstore?.organizationData?.data?.length > 0
                            ? organizationstore?.organizationData?.data.map((item) => ({
                              value: item?.organizationID ?? '',
                              label: item?.organizationName,
                            }))
                            : [{ value: '', label: 'Not Found' }]}
                          handleSelectChange={handleOrgChange}
                        />
                      </div>

                      <div className="lead-modal-field">
                        <label htmlFor="labelID" className="lead-modal-label">Label</label>
                        <div className="lead-modal-inline-control">
                          <ReactSelect
                            selectedValue={selectedLable}
                            options={store && store?.getAllLabel?.length > 0
                              ? store?.getAllLabel.map((item) => ({
                                value: item?.value,
                                label: item?.text,
                              }))
                              : [{ value: '', label: 'Not Found' }]}
                            handleSelectChange={handleLableChange}
                          />
                          <FiPlusCircle
                            size={28}
                            className="lead-modal-add-label"
                            onClick={() => setOpenLabelModel(true)}
                          />
                        </div>
                      </div>

                      <div className="lead-modal-field">
                        <label htmlFor="ownerID" className="lead-modal-label">Owner</label>
                        <input
                          type="text"
                          {...register("Owner")}
                          className="lead-modal-input capitalize"
                        />
                      </div>

                      <div className="lead-modal-field">
                        <label htmlFor="visibleTo" className="lead-modal-label">Visible to</label>
                        <ReactSelect
                          selectedValue={selectedVisible}
                          options={store && store?.getAllVisibleTo?.length > 0
                            ? store?.getAllVisibleTo.map((item) => ({
                              value: item?.value,
                              label: item?.text,
                            }))
                            : [{ value: '', label: 'Not Found' }]}
                          handleSelectChange={handleVisibleChange}
                        />
                      </div>
                    </div>
                  </div>

                  <div className="lead-modal-section">
                    <div className="lead-modal-section-header">
                      <span className="lead-modal-section-dot lead-modal-section-dot-blue" />
                      <h4>Contact details</h4>
                    </div>
                    <div className="lead-modal-section-content">
                      <div className="lead-modal-field">
                        <label htmlFor="phoneNumber" className="lead-modal-label">Phone</label>
                        <div className="lead-modal-stack">
                          {allPhone?.map((item, index) => (
                            <div key={index} className="lead-modal-contact-row">
                              <div className="lead-modal-contact-input">
                                <PhoneInput
                                  value={item?.phone}
                                  onChange={(value, country) => handlePhoneChange(value, index, country)}
                                  id={`phone_${index}`}
                                  country="in"
                                  error={true}
                                  containerClass="lead-phone-container"
                                  inputClass="lead-phone-input"
                                  buttonClass="lead-phone-button"
                                  inputProps={{
                                    name: 'phone',
                                    country: 'in',
                                    required: true,
                                    autoFocus: true,
                                  }}
                                />
                                {error[`Phone-${index}`] && <p className="lead-modal-error">{error[`Phone-${index}`]}</p>}
                              </div>
                              <select
                                id={`phoneType_${index}`}
                                onChange={(e) => handlePhoneTypeChange(e, index)}
                                value={item?.Type}
                                className="lead-modal-type-select"
                              >
                                <option value="Work">Work</option>
                                <option value="Home">Home</option>
                                <option value="Mobile">Mobile</option>
                                <option value="Other">Other</option>
                              </select>
                              <RiDeleteBinLine
                                className="lead-modal-delete"
                                size={20}
                                onClick={() => {
                                  const updatedQuestions = allPhone.filter((_, i) => i !== index);
                                  setAllPhone(updatedQuestions);
                                }}
                              />
                            </div>
                          ))}
                        </div>
                        <button
                          type="button"
                          className="lead-modal-add-btn"
                          onClick={() => setAllPhone([...allPhone, { phone: '', Type: '', country: 'in' }])}
                        >
                          <FaPlus />
                          <span>Phone</span>
                        </button>
                      </div>

                      <div className="lead-modal-field">
                        <label htmlFor="email" className="lead-modal-label">Email</label>
                        <div className="lead-modal-stack">
                          {allEmail?.map((item, index) => (
                            <div key={index} className="lead-modal-contact-row">
                              <div className="lead-modal-contact-input">
                                <input
                                  type="text"
                                  id={`Email-[${index}]`}
                                  name={`Email-[${index}]`}
                                  placeholder="Enter Email"
                                  className="lead-modal-input"
                                  value={item?.email || ''}
                                  onChange={(e) => handleEmailChange(e, index)}
                                />
                                {error[`Email-${index}`] && <p className="lead-modal-error">{error[`Email-${index}`]}</p>}
                              </div>
                              <select
                                id={`emailType_${index}`}
                                value={item.Type}
                                onChange={(e) => handleEmailTypeChange(e, index)}
                                className="lead-modal-type-select"
                              >
                                <option value="Work">Work</option>
                                <option value="Home">Home</option>
                                <option value="Other">Other</option>
                              </select>
                              <RiDeleteBinLine
                                className="lead-modal-delete"
                                size={20}
                                onClick={() => {
                                  const updatedQuestions = allEmail.filter((_, i) => i !== index);
                                  setAllEmail(updatedQuestions);
                                }}
                              />
                            </div>
                          ))}
                        </div>
                        <button
                          type="button"
                          className="lead-modal-add-btn"
                          onClick={() => setAllEmail([...allEmail, { email: '', Type: '' }])}
                        >
                          <FaPlus />
                          <span>Email</span>
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div className="lead-modal-footer">
                <button
                  type="button"
                  className="px-4 py-2 border border-slate-200 dark:border-slate-700 text-slate-600 dark:text-slate-300 hover:bg-slate-100 dark:hover:bg-slate-800 text-sm font-semibold rounded-lg transition-colors cursor-pointer mr-2"
                  onClick={() => togglemodel()}
                >
                  Close
                </button>
                <button
                  type="submit"
                  className="px-5 py-2 bg-indigo-600 hover:bg-indigo-700 text-white text-sm font-semibold rounded-lg shadow-md hover:shadow-lg transition-all duration-200 cursor-pointer"
                >
                  {Person?.personMasterID ? 'Update' : 'Save'}
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
      {openLabelModel && (
        <AddLabel
          setOpenLabelModel={setOpenLabelModel}
          openLabelModel={openLabelModel}
        />
      )}
    </>
  );
};

export default AddEditPerson;
